module.exports = __webpack_public_path__ + "static/media/envelope_icon.b63fee60.svg";